export default "__VITE_ASSET__BL7Q0hlU__"